import React, {useEffect, useState} from 'react';
import { Box,   } from '@mui/material';
import PageContent from './partials/PageContent'
import PageHeader from './partials/PageHeader'
import { getPageSolutionPackageData } from "../../../services/pages";
import Preloader from '../../common/Preloader'; 
import AOS from 'aos';

const PagePackagesSolutions = () => {

  useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);
    const [pageData, setPagesData] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const [pageResponse,] = await Promise.all([ getPageSolutionPackageData(),  ]);          
          setPagesData(pageResponse || {});
        } catch (error) {
          console.error("Error fetching data:", error.response || error.message);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, []);
  
    if (loading) { return <Preloader />; }
  
    const { title, description, content, image } = pageData.page_package;

  return (
  <Box className="solution-page" id="page-packege">
    <PageHeader 
      title={title}
      next="Automatización Robótica de Procesos (RPA)" 
      hrefNext="/solutions/automation" 
      prev="End to End Trenes"
      hrefPrev="/solutions/trains"
    />
    <PageContent 
      content={content} 
      title={title} 
      description={description} 
      image={image}
    /> 
  </Box>)
}

export default PagePackagesSolutions;


